import { browserLocalPersistence, connectAuthEmulator, getAuth } from "firebase/auth";
import { app } from "./initialize-app";

export const auth = getAuth(app);

// Set the local persistence to be used by Firebase Auth
auth.setPersistence(browserLocalPersistence);

// Connect to the Auth Emulator
process.env.NODE_ENV !== "production" &&
  process.env.NEXT_PUBLIC_FIREBASE_USE_EMULATOR === "true" &&
  connectAuthEmulator(auth, "http://localhost:9099");
